/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftToggleButton',['pixi', 'absolute', 'lodash'],

    function (PIXI, Absolute, _) {

        var MsftToggleButton = function (options) {

            var defaultOptions = {
                text: '',
                setting: false,
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 23 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                toggleOff: 'toggle_switch_off.png',
                toggleOn: 'toggle_switch_on.png',
                onLabel: 'buttons.on',
                offLabel: 'buttons.off',
                toggleDot: 'toggle_dot.png'
            };

            this._initMsftToggleButton(_.extend(defaultOptions, options));
        };


        MsftToggleButton.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
        MsftToggleButton.prototype.constructor = MsftToggleButton;

        MsftToggleButton.prototype._initMsftToggleButton = function (options) {
            PIXI.DisplayObjectContainer.call(this);
            this.options = options;
            this.on = this.options.setting;
            this.onLabel = Absolute.StringManager(this.options.onLabel);
            this.offLabel = Absolute.StringManager(this.options.offLabel);
            this.value = this.options.value;

            this.label = new PIXI.Text(this.options.text, this.options.letterStyle);
            Absolute.StringManager.shrinkToFit(this.label,
                Absolute.StringManager.extractNumbersFromString(this.options.letterStyle.font), '', Absolute.Coords.x(250));
            this.addChild(this.label);

            this.offDisplay = this._createDisplay('off');
            this.onDisplay = this._createDisplay('on');
            this.offDisplay.y = this.onDisplay.y = this.label.text.trim() !== "" ? this.label.height + Absolute.Coords.y(5) : 0;

            this.interactive = true;
            this.buttonMode = true;
            this._hasFocus = false;

            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.clear();
            this.focusIndicator.lineStyle(1, 0xFFFFFF);
            var margin = Absolute.Coords.x(4);
            this.focusIndicator.drawRect(-margin, -margin, this.offDisplay.width + 2 * margin, this.offDisplay.height + 2 * margin);
            this.focusIndicator.position.set(this.offDisplay.x, this.offDisplay.y);


            if (Absolute.Platform.supportsTouch()) {

                this.touchstart = function (evt) {
                    this.handleAction();
                };

                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }

            } else {
                this.bindMouseEvents();
            }

            this.updateState(this.on);
            this._height = this.height + Absolute.Coords.y(12);

            this.hitArea = new PIXI.Rectangle(0, 0, this.width * 1.2, this.height * 1.2);
        };

        MsftToggleButton.prototype.bindMouseEvents = function () {

            this.mousedown = function (evt) {
                return false;
            };

            this.mouseup = function (evt) {
                this.handleAction();
            }.bind(this);
        };

        MsftToggleButton.prototype.handleAction = function () {

            Absolute.AudioManager.playSound('button');

            this.on = !this.on;

            this.updateState(this.on);
            this.options.action(this.options.settingPrefix, this.options.settingsKey, this.on);
        };

        MsftToggleButton.prototype.updateState = function (setting) {
            this.options.setting = setting;
            this.on = setting;
            if (this.on) {
                if (this.children.indexOf(this.offDisplay) != -1) {
                    this.removeChild(this.offDisplay);
                }
                this.addChild(this.onDisplay);
            } else {
                if (this.children.indexOf(this.onDisplay) != -1) {
                    this.removeChild(this.onDisplay);
                }
                this.addChild(this.offDisplay);
            }
        };


        MsftToggleButton.prototype._createDisplay = function (type) {

            var container = new PIXI.DisplayObjectContainer(),
                radio = PIXI.Sprite.fromFrame(type === 'on' ? this.options.toggleOn : this.options.toggleOff),
                textIndicator = new PIXI.Text(type === 'off' ? this.offLabel : this.onLabel, this.options.letterStyle),
                dotOffsetOn = Absolute.Coords.x(8),
                dotOffsetOff = Absolute.Coords.x(-2);

            radio.x = Absolute.Coords.x(4);
            textIndicator.x = radio.x + radio.width + Absolute.Coords.x(10);
            radio.y = (textIndicator.height - radio.height) / 2 + Absolute.Coords.y(3);
            textIndicator.y = Absolute.Coords.y(6);
            container.addChild(radio);
            container.addChild(textIndicator);
            if (this.options.toggleDot !== 'noDot') {
                var dotSprite = PIXI.Sprite.fromFrame(this.options.toggleDot);
                dotSprite.scale.set(1.4, 1.4);
                dotSprite.y = radio.y + (radio.height - dotSprite.height) / 2;
                dotSprite.x = type === 'on' ?
                    radio.x + radio.width - dotSprite.width - dotOffsetOn :
                    radio.x + dotSprite.width + dotOffsetOff;
            }
            if (this.options.toggleDot !== 'noDot') container.addChild(dotSprite);
            container.addChild(textIndicator);

            return new PIXI.Sprite(container.generateTexture());
        };

        MsftToggleButton.prototype.handleActivate = function () {
            this.handleAction();
        };


        MsftToggleButton.prototype._focusChanged = function () {
            if (this._hasFocus) {
                this.addChild(this.focusIndicator);
            } else {
                if (this.children.indexOf(this.focusIndicator) !== -1) {
                    this.removeChild(this.focusIndicator);
                }
            }
        };

        Object.defineProperty(MsftToggleButton.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        return MsftToggleButton;

    });

